export default (baseDomain: string, isNext: number) =>
  `${baseDomain}/ha-sw-${isNext ? 'next' : 'precache'}.js`;
